import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { createEmptyPassageJson } from '../utils/passageAuthoring'

interface PassageEditorState {
  selectedPassageId: string | null
  json: string
}

const initialState: PassageEditorState = {
  selectedPassageId: null,
  json: createEmptyPassageJson(),
}

const passageEditorSlice = createSlice({
  name: 'passageEditor',
  initialState,
  reducers: {
    startPassage: () => ({ ...initialState, json: createEmptyPassageJson() }),
    loadPassage: (state, action: PayloadAction<{ id: string; json: string }>) => {
      state.selectedPassageId = action.payload.id
      state.json = action.payload.json
    },
  },
})

export const {
  startPassage,
  loadPassage,
} = passageEditorSlice.actions

export default passageEditorSlice.reducer
